export default __webpack_public_path__ + "media/images/gallery/7-22e57e203d0703b7eb9dfdbd9dfb5624.jpg";